import { Building2, ShieldQuestion } from 'lucide-react';
import { Link } from 'react-router';

import { EstadoVazio } from '@/ui/components/estado-vazio';
import { estiloBotao } from '@/ui/primitives/estilos';

/**
 * Sem nenhuma empresa no escopo não há nota para mostrar: em vez de painéis vazios (ou 403),
 * a tela diz o próximo passo — cadastrar a primeira empresa ou pedir acesso.
 */
export function PrimeirosPassos({ podeCadastrar }: { podeCadastrar: boolean }) {
  if (podeCadastrar) {
    return (
      <EstadoVazio
        icone={<Building2 aria-hidden />}
        titulo="Cadastre a primeira empresa"
        texto="As notas são organizadas por empresa. Cadastre o CNPJ e o regime tributário e depois importe os XMLs ou o relatório de notas destinadas da SEFAZ."
        acao={
          <Link to="/empresas" className={estiloBotao({ variante: 'primario' })}>
            Cadastrar empresa
          </Link>
        }
      />
    );
  }
  return (
    <EstadoVazio
      icone={<ShieldQuestion aria-hidden />}
      titulo="Você ainda não tem acesso a nenhuma empresa"
      texto="Peça ao administrador do FiscoAI para incluir você nas empresas em que trabalha."
    />
  );
}
